// Bilingual content — Romanian (default) and English
export const translations = {
  ro: {
    nav: {
      home: "Acasă",
      services: "Servicii",
      portfolio: "Portofoliu",
      about: "Despre",
      contact: "Contact",
      cta: "Începe acum",
    },
    preloader: {
      loading: "Se încarcă...",
      welcome: "Bine ai venit",
    },
    hero: {
      eyebrow: "Agenție Digitală Premium",
      title_line1: "Destinul tău",
      title_line2: "în social media.",
      subtitle:
        "Creăm campanii de ads și conținut social media care transformă brandurile în povești memorabile. Rezultate reale, nu promisiuni.",
      cta_primary: "Începe proiectul tău",
      cta_secondary: "Vezi serviciile",
      scroll: "Derulează",
    },
    marquee: ["Meta Ads", "Google Ads", "TikTok Ads", "LinkedIn Ads", "Social Media", "Content Strategy", "Branding"],
    stats: {
      title: "Impact în cifre",
      subtitle: "Creștere care se citește în analytics.",
      description:
        "De la primele impresii la loialitate — construim rezultate vizibile, nu doar rapoarte frumoase.",
      items: [
        { value: "+120", label: "Branduri lansate" },
        { value: "5.8M", label: "Impresii generate" },
        { value: "4.2x", label: "ROI mediu pe ads" },
        { value: "98%", label: "Clienți revin" },
      ],
    },
    services: {
      eyebrow: "Ce facem",
      title: "Servicii create pentru creștere",
      subtitle:
        "Două direcții, un singur scop: să transformăm atenția publicului în clienți fideli.",
      items: [
        {
          tag: "01",
          title: "Ads pe toate platformele",
          description:
            "Campanii Meta, Google, TikTok, LinkedIn, YouTube – strategie, creație, setup și optimizare zi de zi pentru ROI maxim.",
          bullets: ["Meta & Instagram Ads", "Google Ads & YouTube", "TikTok & LinkedIn", "Optimizare zilnică"],
        },
        {
          tag: "02",
          title: "Social Media Management",
          description:
            "Conținut care oprește scroll-ul. Gestionăm complet prezența ta online: strategie, foto, video, copy și community.",
          bullets: ["Strategie editorială", "Producție foto & video", "Copywriting", "Community management"],
        },
      ],
      cta: "Vezi toate serviciile",
    },
    process: {
      eyebrow: "Procesul",
      title: "Patru pași simpli către rezultate reale",
      steps: [
        { n: "01", title: "Discovery", desc: "Analizăm brandul, publicul și obiectivele." },
        { n: "02", title: "Strategie", desc: "Construim un plan cap-coadă pentru creștere." },
        { n: "03", title: "Execuție", desc: "Producem, lansăm și testăm creativele." },
        { n: "04", title: "Optimizare", desc: "Scalăm ce funcționează, oprim ce nu." },
      ],
    },
    testimonials: {
      eyebrow: "Ei vorbesc despre noi",
      title: "Povești spuse de clienți reali",
      items: [
        { quote: "Social Destiny ne-a dublat vânzările online în trei luni. Singura agenție care explică cifrele clar.", name: "Andreea Popescu", username: "@atelier_noir", role: "Fondator, Atelier Noir", country: "🇷🇴 România" },
        { quote: "Campaniile Meta și TikTok ne-au adus leaduri de 3x mai ieftine. Recomand cu încredere.", name: "Radu Ionescu", username: "@urbanfit", role: "CEO, Urban Fit", country: "🇷🇴 România" },
        { quote: "Echipa e obsedată de detalii. Creativele, copy-ul, raportările – totul la standard premium.", name: "Maria Dumitrescu", username: "@casaverde", role: "Marketing Lead, Casa Verde", country: "🇷🇴 România" },
        { quote: "În 6 săptămâni am ieșit pe profit din Meta Ads. Nimeni altcineva nu reușise până atunci.", name: "Cristian Voicu", username: "@brewlab", role: "Co-founder, BrewLab", country: "🇷🇴 România" },
        { quote: "Au preluat complet social media. Nu mai trebuie să mă gândesc la nimic, iar rezultatele se văd.", name: "Diana Ristea", username: "@studio_dr", role: "Owner, Studio DR", country: "🇲🇩 Moldova" },
        { quote: "TikTok-ul nostru a explodat. 0 la 80k followers în 4 luni, cu ROI real pe site.", name: "Paul Georgescu", username: "@kineticwear", role: "Founder, Kinetic Wear", country: "🇷🇴 România" },
        { quote: "Raportările săptămânale ne ajută să luăm decizii, nu să ne uităm la cifre goale.", name: "Ioana Stan", username: "@lumegold", role: "E-com Manager, Lume Gold", country: "🇷🇴 România" },
        { quote: "Am colaborat cu 4 agenții înainte. Social Destiny face cât toate la un loc.", name: "Alexandru Marin", username: "@northpeak", role: "CMO, North Peak", country: "🇷🇴 România" },
        { quote: "Creative video premium și strategie care scalează. Exact ce căutam.", name: "Bianca Tudor", username: "@bella_casa", role: "Fondator, Bella Casa", country: "🇮🇹 Italia" },
      ],
    },
    cta_section: {
      eyebrow: "Hai să începem",
      title: "Următorul brand de succes poate fi al tău.",
      subtitle:
        "O conversație de 20 de minute poate schimba direcția afacerii tale. Nu costă nimic.",
      button: "Rezervă o discuție",
    },
    footer: {
      tagline: "Agenția care îți scrie destinul digital.",
      explore: "Explorează",
      services_title: "Servicii",
      services_list: ["Social Media Management", "Campanii ADS", "Website", "Consultanță"],
      contact_title: "Contact",
      rights: "Toate drepturile rezervate.",
      made_with: "Creat cu grijă în București.",
    },
    about: {
      eyebrow: "Despre Social Destiny",
      title: "Construim branduri memorabile prin social media și ads.",
      lead:
        "Social Destiny s-a născut din convingerea că fiecare brand are o poveste. Noi o traducem în campanii care cresc și în conținut care vinde.",
      p1:
        "Lucrăm cu antreprenori, fondatori și echipe de marketing care vor mai mult decât likes. Vor creștere. Vor conversii. Vor brand.",
      p2:
        "Combinăm strategia de performance marketing cu creativitatea conținutului premium. Pentru că reclamele funcționează cel mai bine când comunică o identitate clară.",
      values_title: "Valorile noastre",
      values: [
        { title: "Transparență", desc: "Rapoarte clare, cifre reale, zero jargoane." },
        { title: "Creativitate", desc: "Fiecare post, fiecare ad — construit să iasă în evidență." },
        { title: "Rezultate", desc: "Nu ne plătești pentru muncă. Ne plătești pentru rezultate." },
        { title: "Parteneriat", desc: "Suntem o extensie a echipei tale, nu un furnizor extern." },
      ],
      team_title: "Fondator",
      team_name: "Alex Marinescu",
      team_role: "Founder & Head of Strategy",
      team_bio:
        "7+ ani de experiență în performance marketing și branding. A condus campanii pentru peste 120 de branduri, de la startup-uri la companii enterprise.",
      section_image_title: "Brandul tău nu are nevoie de mai mult conținut. Are nevoie de o direcție.",
      section_image_body:
        "Ce facem noi diferit e simplu: înainte să apăsăm vreun buton pe Ads Manager sau să publicăm vreun reel, stăm jos și înțelegem. Ce vrea clientul tău, ce te diferențiază de competiție, unde se ascund oportunitățile reale. Abia apoi construim.",
      section_image_points: [
        "Strategie înainte de execuție",
        "Echipă mică, focus maxim",
        "Transparență totală pe cifre",
        "Parteneriat pe termen lung",
      ],
    },
    services_page: {
      eyebrow: "Serviciile noastre",
      title: "Ce poate face Social Destiny pentru tine.",
      subtitle:
        "Alege o direcție sau combină-le. În ambele cazuri, livrăm strategia, creația și rezultatele.",
      detailed: [
        {
          num: "01",
          title: "Ads pe toate platformele",
          intro:
            "Campanii performance pe Meta, Google, TikTok, LinkedIn și YouTube. De la primul test până la scalare agresivă.",
          features: [
            "Audit complet al contului și strategiei actuale",
            "Structură cont optimizată pentru scalare",
            "Creative testing săptămânal (video, static, UGC)",
            "Landing page feedback și CRO tips",
            "Raportare săptămânală cu insights acționabile",
            "Consultanță directă cu strategul",
          ],
        },
        {
          num: "02",
          title: "Social Media Management",
          intro:
            "Prezență completă pe Instagram, TikTok, Facebook și LinkedIn. Conținut premium, publicare, community și strategie lunară.",
          features: [
            "Strategie editorială lunară pe canal",
            "Producție foto & video de la A la Z",
            "Copywriting optimizat pentru engagement",
            "Publicare și community management zilnic",
            "Reels & TikToks focusate pe reach organic",
            "Analiză lunară de performanță",
          ],
        },
      ],
      cta_title: "Nu ești sigur ce se potrivește brandului tău?",
      cta_subtitle: "Hai să vorbim 20 de minute. Îți spunem direct ce merită făcut.",
      cta_button: "Programează o discuție",
    },
    contact: {
      eyebrow: "Hai să vorbim",
      title: "Începe povestea cu Social Destiny.",
      subtitle:
        "Completează formularul și îți răspundem în maxim 24 de ore. Fără pitch-uri lungi, doar răspunsuri directe.",
      form: {
        name: "Numele tău",
        email: "Email",
        phone: "Telefon (opțional)",
        service: "Ce te interesează?",
        service_options: ["Ads pe platforme", "Social Media Management", "Ambele", "Altceva"],
        budget: "Buget lunar estimat",
        budget_options: ["<500€", "500 – 1.500€", "1.500 – 5.000€", "5.000€+", "Nu știu încă"],
        message: "Spune-ne despre proiect",
        submit: "Trimite mesajul",
        submitting: "Se trimite...",
        success: "Mulțumim! Te contactăm în curând.",
        error: "A apărut o eroare. Te rugăm încearcă din nou.",
        rate_limited:
          "Prea multe încercări din aceeași rețea. Așteaptă câteva minute și încearcă din nou.",
      },
      info_title: "Alte căi de contact",
      email_label: "Email",
      phone_label: "Telefon",
      location_label: "Birou",
      location_value: "București, România",
      hours_label: "Program",
      hours_value: "Luni – Vineri, 09:00 – 18:00",
    },
    portfolio: {
      eyebrow: "Portofoliu",
      title: "Branduri care au crescut cu noi.",
      subtitle: "Selecție de proiecte la care am lucrat recent. De la ecommerce la servicii și branduri de lifestyle.",
      cta: "Hai să construim și povestea ta",
      items: [
        { name: "Atelier Noir", service: "Social Media + Meta Ads", image: "https://images.unsplash.com/photo-1490481651871-ab68de25d43d?auto=format&fit=crop&w=1200&q=80" },
        { name: "Urban Fit", service: "TikTok Ads + Web", image: "https://images.unsplash.com/photo-1534438327276-14e5300c3a48?auto=format&fit=crop&w=1200&q=80" },
        { name: "Casa Verde", service: "Social Media Management", image: "https://images.unsplash.com/photo-1441986300917-64674bd600d8?auto=format&fit=crop&w=1200&q=80" },
        { name: "BrewLab", service: "Performance Marketing", image: "https://images.unsplash.com/photo-1511920170033-f8396924c348?auto=format&fit=crop&w=1200&q=80" },
        { name: "Kinetic Wear", service: "Branding + Ecommerce", image: "https://images.unsplash.com/photo-1556906781-9a412961c28c?auto=format&fit=crop&w=1200&q=80" },
        { name: "Lume Gold", service: "Google Ads + SEO", image: "https://images.unsplash.com/photo-1515562141207-7a88fb7ce338?auto=format&fit=crop&w=1200&q=80" },
        { name: "North Peak", service: "Consultanță + Strategie", image: "https://images.unsplash.com/photo-1519748771451-a94c596fad67?auto=format&fit=crop&w=1200&q=80" },
        { name: "Studio DR", service: "Website + Social Media", image: "https://images.unsplash.com/photo-1556761175-5973dc0f32e7?auto=format&fit=crop&w=1200&q=80" },
        { name: "Bella Casa", service: "Meta Ads + Content", image: "https://images.unsplash.com/photo-1524758631624-e2822e304c36?auto=format&fit=crop&w=1200&q=80" },
      ],
    },
    trusted: "+120 de clienți au scris un capitol cu noi",
  },
  en: {
    nav: {
      home: "Home",
      services: "Services",
      portfolio: "Portfolio",
      about: "About",
      contact: "Contact",
      cta: "Get started",
    },
    preloader: {
      loading: "Loading...",
      welcome: "Welcome",
    },
    hero: {
      eyebrow: "Premium Digital Agency",
      title_line1: "Your destiny",
      title_line2: "in social media.",
      subtitle:
        "We craft ad campaigns and social media content that turn brands into memorable stories. Real results, not promises.",
      cta_primary: "Start your project",
      cta_secondary: "See our services",
      scroll: "Scroll",
    },
    marquee: ["Meta Ads", "Google Ads", "TikTok Ads", "LinkedIn Ads", "Social Media", "Content Strategy", "Branding"],
    stats: {
      title: "Impact by the numbers",
      subtitle: "Growth you can actually read in analytics.",
      description:
        "From first impressions to loyalty — we build metrics that matter, not vanity dashboards.",
      items: [
        { value: "+120", label: "Brands launched" },
        { value: "5.8M", label: "Impressions generated" },
        { value: "4.2x", label: "Average ROI on ads" },
        { value: "98%", label: "Client retention" },
      ],
    },
    services: {
      eyebrow: "What we do",
      title: "Services built for growth",
      subtitle:
        "Two directions, one goal: turning audience attention into loyal customers.",
      items: [
        {
          tag: "01",
          title: "Ads on every platform",
          description:
            "Meta, Google, TikTok, LinkedIn and YouTube campaigns — strategy, creative, setup and daily optimisation for maximum ROI.",
          bullets: ["Meta & Instagram Ads", "Google Ads & YouTube", "TikTok & LinkedIn", "Daily optimisation"],
        },
        {
          tag: "02",
          title: "Social Media Management",
          description:
            "Content that stops the scroll. We manage your online presence from strategy to photo, video, copy and community.",
          bullets: ["Editorial strategy", "Photo & video production", "Copywriting", "Community management"],
        },
      ],
      cta: "View all services",
    },
    process: {
      eyebrow: "The process",
      title: "Four simple steps to real results",
      steps: [
        { n: "01", title: "Discovery", desc: "We analyse your brand, audience and goals." },
        { n: "02", title: "Strategy", desc: "We build an end-to-end plan for growth." },
        { n: "03", title: "Execution", desc: "We produce, launch and test creatives." },
        { n: "04", title: "Optimisation", desc: "We scale what works, stop what doesn't." },
      ],
    },
    testimonials: {
      eyebrow: "They talk about us",
      title: "Stories told by real clients",
      items: [
        { quote: "Social Destiny doubled our online sales in three months. The only agency that explains the numbers clearly.", name: "Andreea Popescu", username: "@atelier_noir", role: "Founder, Atelier Noir", country: "🇷🇴 Romania" },
        { quote: "The Meta and TikTok campaigns brought us leads 3x cheaper. I fully recommend them.", name: "Radu Ionescu", username: "@urbanfit", role: "CEO, Urban Fit", country: "🇷🇴 Romania" },
        { quote: "The team is obsessed with details. Creatives, copy, reporting — all premium.", name: "Maria Dumitrescu", username: "@casaverde", role: "Marketing Lead, Casa Verde", country: "🇷🇴 Romania" },
        { quote: "In 6 weeks we turned profitable on Meta Ads. No one else managed that before.", name: "Cristian Voicu", username: "@brewlab", role: "Co-founder, BrewLab", country: "🇷🇴 Romania" },
        { quote: "They fully took over social media. I don't have to think about it — and the results show.", name: "Diana Ristea", username: "@studio_dr", role: "Owner, Studio DR", country: "🇲🇩 Moldova" },
        { quote: "Our TikTok exploded. 0 to 80k followers in 4 months with real ROI on the site.", name: "Paul Georgescu", username: "@kineticwear", role: "Founder, Kinetic Wear", country: "🇷🇴 Romania" },
        { quote: "Weekly reports help us make decisions, not just stare at empty numbers.", name: "Ioana Stan", username: "@lumegold", role: "E-com Manager, Lume Gold", country: "🇷🇴 Romania" },
        { quote: "We worked with 4 agencies before. Social Destiny does as much as all of them combined.", name: "Alexandru Marin", username: "@northpeak", role: "CMO, North Peak", country: "🇷🇴 Romania" },
        { quote: "Premium video creatives and a strategy that scales. Exactly what we needed.", name: "Bianca Tudor", username: "@bella_casa", role: "Founder, Bella Casa", country: "🇮🇹 Italy" },
      ],
    },
    cta_section: {
      eyebrow: "Let's get started",
      title: "The next success story could be yours.",
      subtitle:
        "A 20-minute conversation could change your business direction. No cost attached.",
      button: "Book a call",
    },
    footer: {
      tagline: "The agency writing your digital destiny.",
      explore: "Explore",
      services_title: "Services",
      services_list: ["Social Media Management", "ADS Campaigns", "Websites", "Consulting"],
      contact_title: "Contact",
      rights: "All rights reserved.",
      made_with: "Crafted with care in Bucharest.",
    },
    about: {
      eyebrow: "About Social Destiny",
      title: "We build memorable brands through social media and ads.",
      lead:
        "Social Destiny was born from the belief that every brand has a story. We translate it into campaigns that grow and content that sells.",
      p1:
        "We work with entrepreneurs, founders and marketing teams who want more than likes. They want growth. They want conversions. They want a brand.",
      p2:
        "We combine performance marketing strategy with premium content creativity. Because ads work best when they communicate a clear identity.",
      values_title: "Our values",
      values: [
        { title: "Transparency", desc: "Clear reports, real numbers, zero jargon." },
        { title: "Creativity", desc: "Every post, every ad — built to stand out." },
        { title: "Results", desc: "You're not paying for work. You're paying for results." },
        { title: "Partnership", desc: "We're an extension of your team, not an external vendor." },
      ],
      team_title: "Founder",
      team_name: "Alex Marinescu",
      team_role: "Founder & Head of Strategy",
      team_bio:
        "7+ years of experience in performance marketing and branding. Led campaigns for 120+ brands, from startups to enterprise companies.",
      section_image_title: "Your brand doesn't need more content. It needs direction.",
      section_image_body:
        "What we do differently is simple: before we press any button in Ads Manager or publish any reel, we sit down and understand. What your client wants, what sets you apart, where the real opportunities hide. Only then do we build.",
      section_image_points: [
        "Strategy before execution",
        "Small team, maximum focus",
        "Total transparency on numbers",
        "Long-term partnership",
      ],
    },
    services_page: {
      eyebrow: "Our services",
      title: "What Social Destiny can do for you.",
      subtitle:
        "Pick a direction or combine them. Either way, we deliver the strategy, the creative and the results.",
      detailed: [
        {
          num: "01",
          title: "Ads on every platform",
          intro:
            "Performance campaigns on Meta, Google, TikTok, LinkedIn and YouTube. From the first test to aggressive scaling.",
          features: [
            "Complete audit of current account and strategy",
            "Account structure optimised for scaling",
            "Weekly creative testing (video, static, UGC)",
            "Landing page feedback and CRO tips",
            "Weekly reporting with actionable insights",
            "Direct consulting with the strategist",
          ],
        },
        {
          num: "02",
          title: "Social Media Management",
          intro:
            "Full presence on Instagram, TikTok, Facebook and LinkedIn. Premium content, publishing, community and monthly strategy.",
          features: [
            "Monthly editorial strategy per channel",
            "Photo & video production from A to Z",
            "Engagement-optimised copywriting",
            "Daily publishing and community management",
            "Reels & TikToks focused on organic reach",
            "Monthly performance analysis",
          ],
        },
      ],
      cta_title: "Not sure what fits your brand?",
      cta_subtitle: "Let's talk for 20 minutes. We'll tell you directly what's worth doing.",
      cta_button: "Schedule a call",
    },
    contact: {
      eyebrow: "Let's talk",
      title: "Start the story with Social Destiny.",
      subtitle:
        "Fill in the form and we'll reply within 24 hours max. No long pitches, just direct answers.",
      form: {
        name: "Your name",
        email: "Email",
        phone: "Phone (optional)",
        service: "What are you interested in?",
        service_options: ["Platform ads", "Social Media Management", "Both", "Something else"],
        budget: "Estimated monthly budget",
        budget_options: ["<€500", "€500 – €1,500", "€1,500 – €5,000", "€5,000+", "Not sure yet"],
        message: "Tell us about the project",
        submit: "Send message",
        submitting: "Sending...",
        success: "Thanks! We'll be in touch soon.",
        error: "Something went wrong. Please try again.",
        rate_limited:
          "Too many attempts from this network. Please wait a few minutes and try again.",
      },
      info_title: "Other ways to reach us",
      email_label: "Email",
      phone_label: "Phone",
      location_label: "Office",
      location_value: "Bucharest, Romania",
      hours_label: "Hours",
      hours_value: "Monday – Friday, 09:00 – 18:00",
    },
    portfolio: {
      eyebrow: "Portfolio",
      title: "Brands that grew with us.",
      subtitle: "A selection of recent projects. From ecommerce to services and lifestyle brands.",
      cta: "Let's build your story too",
      items: [
        { name: "Atelier Noir", service: "Social Media + Meta Ads", image: "https://images.unsplash.com/photo-1490481651871-ab68de25d43d?auto=format&fit=crop&w=1200&q=80" },
        { name: "Urban Fit", service: "TikTok Ads + Web", image: "https://images.unsplash.com/photo-1534438327276-14e5300c3a48?auto=format&fit=crop&w=1200&q=80" },
        { name: "Casa Verde", service: "Social Media Management", image: "https://images.unsplash.com/photo-1441986300917-64674bd600d8?auto=format&fit=crop&w=1200&q=80" },
        { name: "BrewLab", service: "Performance Marketing", image: "https://images.unsplash.com/photo-1511920170033-f8396924c348?auto=format&fit=crop&w=1200&q=80" },
        { name: "Kinetic Wear", service: "Branding + Ecommerce", image: "https://images.unsplash.com/photo-1556906781-9a412961c28c?auto=format&fit=crop&w=1200&q=80" },
        { name: "Lume Gold", service: "Google Ads + SEO", image: "https://images.unsplash.com/photo-1515562141207-7a88fb7ce338?auto=format&fit=crop&w=1200&q=80" },
        { name: "North Peak", service: "Consulting + Strategy", image: "https://images.unsplash.com/photo-1519748771451-a94c596fad67?auto=format&fit=crop&w=1200&q=80" },
        { name: "Studio DR", service: "Website + Social Media", image: "https://images.unsplash.com/photo-1556761175-5973dc0f32e7?auto=format&fit=crop&w=1200&q=80" },
        { name: "Bella Casa", service: "Meta Ads + Content", image: "https://images.unsplash.com/photo-1524758631624-e2822e304c36?auto=format&fit=crop&w=1200&q=80" },
      ],
    },
    trusted: "+120 clients wrote a chapter with us",
  },
};

export const contactInfo = {
  email: "hello@socialdestiny.ro",
  phone: "+40 725 000 000",
  instagram: "@socialdestiny",
  /** Public URL: static `/logo_sd.png` or `/api/uploads/...` after upload in admin */
  logoUrl: "/logo_sd.png",
  /** Opțional: logo diferit în footer; gol = același ca header */
  footerLogoUrl: "",
  /** Link-uri complete (https://…); goale = ascuns (Instagram poate folosi încă @ din „Instagram”) */
  socialInstagramUrl: "",
  socialFacebookUrl: "",
  socialTiktokUrl: "",
  socialLinkedinUrl: "",
};
